import * as React from 'react'
function SvgIndicatorInfo(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M20 4c8.8 0 16 7.2 16 16s-7.2 16-16 16S4 28.8 4 20 11.2 4 20 4zm0 4C13.4 8 8 13.4 8 20s5.4 12 12 12 12-5.4 12-12S26.6 8 20 8zm0 10a2 2 0 012 2v6a2 2 0 11-4 0v-6a2 2 0 012-2zm0-6a2 2 0 110 4 2 2 0 010-4z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgIndicatorInfo
